import React, { forwardRef } from "react";
import { Star } from "lucide-react";

const resenasData = [
  {
    cliente: "CASA ARAB",
    texto: "Valoro el profesionalismo en todo el proceso. ¡Gracias!",
    cargo: "Guillermo Arab, Director",
  },
  {
    cliente: "G-TEC Desarrollos y Servicios",
    texto:
      "Excelente trabajo y profesionalismo nos brindaron para seleccionar perfiles complejos de encontrar, con una velocidad de respuesta asombrosa.",
    cargo: "Jerónimo Colazo, Gerente General",
  },
  {
    cliente: "G-TEC Desarrollos y Servicios",
    texto:
      "Muy satisfecho con Core Solutions. Muy buen entendimiento, proceso y feedback con las consultoras. Recomiendo sus servicios al 100%.",
    cargo: "Pablo Fernández, Gerente de Recursos Humanos",
  },
  {
    cliente: "Neverland",
    texto: "Julieta es una excelente profesional, conoce muy bien las leyes laborales.",
    cargo: "Miguel Gomez, Adm. de RRHH",
  },
  {
    cliente: "Procom",
    texto:
      "¡Excelente servicio! Gran acompañamiento durante el período requerido, dudas resueltas y procesos bien explicados.",
    cargo: "Brenda Bustos, Liquidadora de Sueldos",
  },
  {
    cliente: "Flexxus",
    texto:
      "Servicio impecable e integral. Gran profesionalismo y cumplimiento de lo acordado.",
    cargo: "Jadur Muhammad, Gerente de RRHH",
  },
  {
    cliente: "FRAMEX",
    texto:
      "Chicas constantes, responsables y comprometidas a encontrar el perfil que más se adecuaba a la vacante.",
    cargo: "Antonella Deltell, RRHH",
  },
  {
    cliente: "Moldear Piscinas",
    texto:
      "Juli, queremos expresarte nuestro agradecimiento por el apoyo y la dedicación que nos has brindado en el proceso de crecimiento organizacional.",
    cargo: "Brisa Mansilla, Coordinadora de Recursos Humanos",
  },
  {
    cliente: "Neverland",
    texto:
      "Julieta es una profesional dedicada, atenta, de carácter reservado y sumamente confiable.",
    cargo: "Matías Gulli, Administración de Personal",
  },
  {
    cliente: "VULCANO SA",
    texto:
      "Entendieron muy bien la necesidad y mantuvieron la alineación durante todo el proceso, incluso adaptándose bien al presupuesto de contratación, siendo muy precisos en lo que se debía ajustar para cumplir con el presupuesto.",
    cargo: "Martin Iudica, Gerente Comercial",
  },
  {
    cliente: "Sveltia",
    texto:
      "Excelente servicio! Nos asesora de manera clara sobre la forma más conveniente de proceder y adapta cada entrega a nuestras necesidades. El servicio es realmente personalizado y se ajusta siempre a lo que requerimos. El trato es cálido y cercano; un placer trabajar en conjunto!",
    cargo: "Magali Lopez, Analista de Capital Humano",
  },
  {
    cliente: "Telgomol",
    texto:
      "Trabajar con la consultoría fue un antes y un después para Telgomol. Nos ayudaron a ordenar procesos, automatizar herramientas y tomar decisiones con una visión más estratégica. Destaco especialmente su capacidad para entender nuestro negocio y detectar oportunidades de mejora. Más que una consultoría, sentimos un verdadero socio estratégico en nuestro crecimiento.",
    cargo: "Agustina Molé, Directora, CEO",
  },
];

const Resenas = forwardRef((props, ref) => {
  const resenasParaAnimacion = [...resenasData, ...resenasData];

  return (
    <section
      ref={ref}
      className="pt-20 pb-32 px-6 bg-[#D1D1CF] text-primary relative overflow-hidden"
    >
      {/* Línea superior decorativa */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-purple-400 via-pink-400 to-purple-400 opacity-30"></div>

      {/* Encabezado */}
      <div className="max-w-6xl mx-auto text-center mb-16">
        <h2 className="text-4xl md:text-5xl font-bold mb-6">Testimonios</h2>
        <p className="text-lg text-gray-700">Lo que dicen nuestros clientes.</p>
      </div>

      {/* Gradientes laterales */}
      <div className="absolute left-0 top-0 h-full w-24 bg-gradient-to-r from-[#D1D1CF]/100 to-[#D1D1CF]/0 pointer-events-none z-10"></div>
      <div className="absolute right-0 top-0 h-full w-24 bg-gradient-to-l from-[#D1D1CF]/100 to-[#D1D1CF]/0 pointer-events-none z-10"></div>

      {/* Carrusel automático */}
      <div className="relative w-full overflow-hidden">
        <div className="flex animate-scroll-reseñas group">
          {resenasParaAnimacion.map((resena, index) => {
            const esBrenda =
              resena.cliente === "Procom" &&
              resena.cargo === "Brenda Bustos, Liquidadora de Sueldos";

            return (
              <div
                key={index}
                className="flex-shrink-0 w-[400px] px-4 flex flex-col items-center text-center group-hover:[animation-play-state:paused] scale-[1]"
              >
                <h3 className="font-bold mb-2" style={{ fontSize: "clamp(16px, 1.5vw, 20px)" }}>
                  {resena.cliente}
                </h3>
                <div className="flex justify-center mb-4">
                  {[...Array(5)].map((_, i) => (
                    <Star
                      key={i}
                      size={20}
                      className="mx-0.5"
                      style={{ color: "#FFA500", fill: "#FFA500", stroke: "none" }}
                    />
                  ))}
                </div>

                <div className="relative w-full flex justify-center">
                  <div
                    className="bg-white p-6 rounded-2xl shadow-xl w-full min-h-[260px] flex flex-col items-center justify-center text-gray-800 border border-gray-200
                    transform transition-transform duration-300 hover:scale-[1.03] hover:shadow-2xl hover:[animation-play-state:paused]"
                    style={{ fontSize: "clamp(14px, 1vw, 15px)" }}
                  >
                    <div className="flex-1 flex items-center">
                      <p
                        className={`leading-relaxed text-gray-700 ${
                          esBrenda ? "text-left" : ""
                        }`}
                        style={
                          esBrenda
                            ? {}
                            : { textAlign: "justify", textJustify: "inter-word" }
                        }
                      >
                        {resena.texto}
                      </p>
                    </div>
                    <p
                      className="text-sm font-semibold text-primary mt-4 text-center"
                      style={{ fontSize: "clamp(12px, 0.9vw, 14px)" }}
                    >
                      {resena.cargo}
                    </p>
                  </div>

                  <div className="absolute -top-1 left-1/2 transform -translate-x-1/2 w-4 h-4 bg-white border-l border-t border-gray-200 rotate-45 shadow-sm"></div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Estilo para animación continua */}
      <style>{`
        @keyframes scroll-reseñas {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        .animate-scroll-reseñas {
          display: flex;
          gap: 2rem;
          width: max-content;
          animation: scroll-reseñas 70s linear infinite;
          animation-play-state: running;
        }

        .animate-scroll-reseñas:hover {
          animation-play-state: paused;
        }

        @media (max-width: 1024px) {
          .animate-scroll-reseñas {
            animation-duration: 58s;
          }
        }

        @media (max-width: 768px) {
          .animate-scroll-reseñas {
            animation-duration: 46s;
          }
        }
      `}</style>
    </section>
  );
});

export default Resenas;
